

export default class AiOperations {
  static PARAMS = 'Params';

  constructor(eventsDomain) {
    this.eventsDomain = eventsDomain;
    this.domain = this.eventsDomain.domain;
  }
  
  contains(name) {
    if (name) {
      //
    }
    return true;
  }
  
  
  prompt(params) {
    var event = new AiOperations.Prompt.Operation(params);
    var wrappedEvent = this.eventsDomain.initRequest(event);
    return wrappedEvent;
  }

  static Prompt = {
    Names: {
      Operation: 'LlmPromptQueryOperation',
      Notification: 'LlmPromptNotification',
    },

    Errors: {
      NotFound: {
        id: 'NotFound',
        msg: 'NotFound',
        details: ''
      },
    },

    Operation: function (params) {
      var event = {
        handler: AiOperations.Prompt.Names.Operation,
        eventName: AiOperations.Prompt.Names.Operation,
      }
      event[AiOperations.PARAMS] = params.data ? params.data : params;
      return event;
    },
  }
  
}